import React from 'react';
import ButtonWrapper from './ButtonWrapper';
import {
  CLONE_MODE,
  CREATE_MODE,
  defaultFilterColumn,
  EDIT_MODE,
  entityType,
  REPORT_MODE,
  UNDO_DELETE_MODE,
  VIEW_MODE,
} from '../../constants';
import { withRouter } from 'react-router';
import { Button, Icon, Popup } from 'semantic-ui-react';

import { ConfirmModal } from 'react-lib/dist/components-es';
import TraceabilityDetails from './TraceabilityDetails';
import { ChemicalProduct, Inventory } from '../../routes';
import { initSelectors } from '../../behavior/init';
import connect from 'react-redux/es/connect/connect';
import { reportsActions } from '../../behavior/reports';
import { GET_PDF_FORMAT, GET_SELECTED_INVENTORIES_REPORT_PATH } from '../../behavior/reports/types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { genericDetailsActions } from '../../behavior/genericDetails';
import { localStorage } from '../../store';
import { isInContacts, isProductEditor } from '../../behavior/init/selectors';
import { getChangedProperties } from '../../utils';
import DownloadInventoryStickersModal from '../Inventory/DownloadInventoryStickersModal';
import { gridTemplatesOptions } from '../../objects/StickerGridTemplate';
import useUser from '@behavior/init/getUserV2';
import { showEditDeleteButton } from '@behavior/init/selectors';

const DetailsFormOptions = ({ ...props }) => {
  const getOptions = () => {
    const {
      mode,
      deleteHandler,
      id,
      history,
      initialValues,
      entityTypeProp,
      submitForm,
      setValidateOnChange,
      toggleValidationMessage,
      t,
      currentInventoryOrgUnit,
      isCurrentlyDeleted,
      currentStep,
      validateAndSetCurrentStep,
      values,
      currentInventoryId,
    } = props;
    const { user } = useUser();
    const routerBasename = props.location.pathname.split(/(?=\/)/g)[0];
    const entityToTrace =
      routerBasename === Inventory.baseName ? initialValues : initialValues.chemicalProduct;
    let options = { right: [], left: [] };

    const initialValuesUserId =
      entityType.inventory === entityTypeProp || entityType.inventoryHist === entityTypeProp
        ? initialValues.createUser && initialValues.createUser.id
        : initialValues.chemicalProduct.createUser && initialValues.chemicalProduct.createUser.id;
    const initialValuesOrgUnitName =
      entityType.inventory === entityTypeProp
        ? initialValues.orgUnit && initialValues.orgUnit.name
        : entityType.inventoryHist === entityTypeProp &&
          currentInventoryOrgUnit &&
          currentInventoryOrgUnit.name
        ? currentInventoryOrgUnit.name
        : null;

    const initialContacts = initialValues.contacts
      ? initialValues.contacts.map(p => p.person.id)
      : [];

    const isCanModifyAsCreator = initSelectors.isCanModifyAsCreator(
      entityTypeProp,
      user,
      initialContacts,
      initialValuesUserId,
      initialValuesOrgUnitName?.split('-')[0]
    );

    const isInventoryOrChemProductCanCreate = initSelectors.isInventoryOrChemProductCanCreate(
      user,
      entityTypeProp
    );

    const isCanModifyEntityOfHistoryAsCreator = initSelectors.isCanModifyAsCreator(
      initSelectors.getEntityTypeBasedOnHistEntityType(entityTypeProp),
      user,
      initialContacts,
      initialValuesUserId
    );
    const isCanModifyEntityOfNotDeletedHistoryAsCreator =
      !isCurrentlyDeleted && isCanModifyEntityOfHistoryAsCreator;
    const isCanUndoDeleteEntityOfHistoryAsCreator =
      isCurrentlyDeleted && isCanModifyEntityOfHistoryAsCreator;

    const isInventoryEntityType = entityType.inventory === entityTypeProp;

    const showEditButtonInViewMode = mode => {
      return (
        [VIEW_MODE].includes(mode) &&
        (isCanModifyAsCreator || isCanModifyEntityOfNotDeletedHistoryAsCreator) &&
        showEditDeleteButton(entityTypeProp, user)
      );
    };

    const showAccessRequestButtonInViewMode = mode => {
      return (
        [VIEW_MODE].includes(mode) &&
        entityTypeProp == entityType.inventory &&
        !isCanModifyAsCreator &&
        isInContacts(initialContacts, user)
      );
    };

    const showInventoryHistoryUndoButton = mode => {
      return (
        entityTypeProp == entityType.inventoryHist &&
        [VIEW_MODE].includes(mode) &&
        isCanUndoDeleteEntityOfHistoryAsCreator
      );
    };

    const showReportProblemButton = mode => {
      return (
        VIEW_MODE === mode &&
        !initSelectors.isProductEditor(user) &&
        !initSelectors.isChemicalSafetyExpert(user) &&
        routerBasename === ChemicalProduct.baseName
      );
    };

    const extractValueFromProperty = val => {
      if (val === null) {
        return 'empty';
      }
      if (Array.isArray(val)) {
        return val.map(v => {
          if (typeof v === 'object') {
            return v.name ? v.name : JSON.stringify(v);
          } else return v;
        });
      }
      if (typeof val === 'object') {
        return val.name ? val.name : JSON.stringify(val);
      }
      return val;
    };

    const buildReportEmail = (id, tradeName, changes) => {
      const lineBreak = '%0D%0A';
      const ceresCseEmail =
        window.NODE_ENV === 'production' ? 'ceres-cse@cern.ch' : 'ceres-cse-test@cern.ch';
      const bugReportSubject =
        window.NODE_ENV === 'production'
          ? `Report a problem for Chemical "${tradeName}" - CERES`
          : `[${window.NODE_ENV}] Report a problem for Chemical "${tradeName}" - CERES ${window.NODE_ENV}`;
      const body = `
  Hello,${lineBreak}${lineBreak}
  I would like to report a problem concerning chemical "${tradeName}" in CERES${
        window.NODE_ENV === 'production' ? '' : ` ${window.NODE_ENV}`
      }.${lineBreak}
  Here are my proposed changes:${lineBreak}${lineBreak}`;
      const proposedChanges = `
  ${Object.keys(changes)
    .map(
      key =>
        `${key}: [${extractValueFromProperty(changes[key].old)}] -> [${extractValueFromProperty(
          changes[key].new
        )}]`
    )
    .join(`${lineBreak}`)}
  ${lineBreak}
`;
      const mailtoString = `mailto:${ceresCseEmail}?subject=${bugReportSubject}&body=${
        body + proposedChanges
      }`;
      return mailtoString.length > 1600
        ? `mailto:${ceresCseEmail}?subject=${bugReportSubject}&body=${body}`
        : mailtoString;
    };

    if (![CREATE_MODE, CLONE_MODE, UNDO_DELETE_MODE].includes(mode)) {
      options.right.push(
        <Popup
          wide="very"
          key="showTraceabilityDetailsButtonKey"
          content={<TraceabilityDetails traceableEntity={entityToTrace} />}
          on={['hover', 'click']}
          position="bottom right"
          trigger={<Button type="button" icon="info circle" />}
        />
      );
    }

    if ([EDIT_MODE].includes(mode) && isCanModifyAsCreator) {
      const routerBasenameSimple = routerBasename.replace('/', '');
      options.right.push(
        <ConfirmModal
          buttonProps={{
            color: 'red',
            icon: 'trash alternate',
          }}
          key="deleteEntityButtonKey"
          header={t(`confirm.modal.delete.${routerBasenameSimple}.title`)}
          content={t(`confirm.modal.delete.${routerBasenameSimple}.content`)}
          confirmFunction={() => deleteHandler(id)}
        />
      );
    }

    if (
      [CLONE_MODE].includes(mode) ||
      ([EDIT_MODE, UNDO_DELETE_MODE].includes(mode) && isCanModifyAsCreator) ||
      ([CREATE_MODE].includes(mode) &&
        isInventoryOrChemProductCanCreate &&
        ((isInventoryEntityType && currentStep > 1) || !isInventoryEntityType))
    ) {
      let buttonText;
      if (mode == EDIT_MODE) {
        buttonText = 'save';
      } else {
        buttonText = mode;
      }
      options.right.push(
        <ButtonWrapper
          key="changesNotificationModalTrigger"
          icon="save"
          type="button"
          label={t(`details.page.${buttonText}.button`)}
          primary={true}
          onClick={() => {
            setValidateOnChange(true);
            toggleValidationMessage();
            submitForm();
          }}
          className="mini right floated"
        />
      );
    }

    if (REPORT_MODE === mode && routerBasename === ChemicalProduct.baseName) {
      // Cancel button when reporting a problem
      options.right.push(
        <Button
          type="button"
          key="cancelButtonKey"
          onClick={() => history.push(`${routerBasename}/view/${id}`)}
        >
          {'Cancel'}
        </Button>
      );

      const oldValues = initialValues.chemicalProduct;
      const newValues = values.chemicalProduct;
      // Report button that opens e-mail template
      options.right.push(
        <Popup
          key="chemical.product.details.page.report.problem.button.tooltip"
          trigger={
            <Button
              type="button"
              key="reportProblemButtonKey"
              color={'orange'}
              onClick={e => {
                window.location = buildReportEmail(
                  oldValues.id,
                  oldValues.tradeName,
                  getChangedProperties(oldValues, newValues)
                );
                e.preventDefault();
              }}
            >
              <Icon name={'mail outline'} />
              {t('details.page.send.report.button')}
            </Button>
          }
          on={['hover']}
          size="mini"
          content={t('chemical.product.details.page.report.problem.button.tooltip')}
          position="bottom right"
        />
      );
    }
    //inventory create mode, steps buttons
    if (
      isInventoryEntityType &&
      [CREATE_MODE].includes(mode) &&
      isInventoryOrChemProductCanCreate
    ) {
      if (currentStep === 1) {
        options.right.push(
          <ButtonWrapper
            onClick={() => {
              validateAndSetCurrentStep(2);
            }}
            icon="chevron right"
            labelPosition="right"
            color="green"
            label={t('details.page.step.2.button')}
            key="step2ButtonKey"
          />
        );
      } else {
        options.left.push(
          <ButtonWrapper
            onClick={() => {
              validateAndSetCurrentStep(1);
            }}
            icon="chevron left"
            color="green"
            label={t('details.page.step.1.button')}
            key="step1ButtonKey"
          />
        );
      }
    }

    if (showEditButtonInViewMode(mode)) {
      let entityId = id;
      if (isCanModifyEntityOfNotDeletedHistoryAsCreator) {
        if (entityTypeProp == entityType.inventoryHist) entityId = initialValues.inventoryId;
        else if (entityTypeProp == entityType.productHist)
          entityId = initialValues.chemicalProduct.chemicalProductId;
      }
      options.right.push(
        <ButtonWrapper
          type="button"
          icon="edit"
          key="editEntityButtonKey"
          primary
          onClick={() => history.push(`${routerBasename}/edit/${entityId}`)}
        />
      );
    }

    if (showAccessRequestButtonInViewMode(mode)) {
      options.right.push(
        <Popup
          key="access.request.key.tooltip"
          trigger={
            <Button
              type="button"
              icon="hand paper outline"
              primary
              key="accessRequestButtonKey"
              onClick={() => history.push(`/accessRequest`)}
            />
          }
          on={['hover']}
          size="mini"
          content={t('details.page.access.request.button.tooltip')}
          position="bottom right"
        />
      );
    }

    if (showInventoryHistoryUndoButton()) {
      let entityId = initialValues.inventoryId;

      options.right.push(
        <Popup
          key="undo.delete.button.tooltip"
          trigger={
            <Button
              type="button"
              icon="undo"
              color="red"
              key="undoDeleteEntityButtonKey"
              onClick={() => history.push(`${routerBasename}/undoDelete/${entityId}`)}
            />
          }
          on={['hover']}
          size="mini"
          content={t('details.page.undo.delete.button.tooltip')}
          position="bottom right"
        />
      );
    }

    if (
      [VIEW_MODE, EDIT_MODE].includes(mode) &&
      initSelectors.isInventoryOrChemProductCanCreate(user, entityType.inventory) &&
      entityType.product === entityTypeProp
    ) {
      options.left.push(
        <Popup
          key="details.page.new.inventory.with.product.button.tooltip"
          trigger={
            <Button
              type="button"
              color="green"
              size="mini"
              labelPosition="left"
              icon="icon-tube-plus"
              key="createInventoryWithProductButtonKey"
              onClick={() => history.push(`${Inventory.baseName}/create?chemProdId=${id}`)}
              content={t('details.page.new.inventory.with.product.button.label')}
            />
          }
          on={['hover']}
          size="mini"
          wide="very"
          content={t('details.page.new.inventory.with.product.button.tooltip')}
          position="bottom left"
        />
      );
    }

    if ([EDIT_MODE, VIEW_MODE].includes(mode) && entityType.inventory === entityTypeProp) {
      options.left.push(
        <ButtonWrapper
          type="button"
          key="export.pdf.button"
          icon="file pdf"
          onClick={() => props.getInventoryReport([id])}
          loading={props.isReportLoading}
          label={t('details.page.export.pdf.button.tooltip')}
        />
      );
    }
    if ([EDIT_MODE, VIEW_MODE, UNDO_DELETE_MODE].includes(mode)) {
      options.left.push(
        <ButtonWrapper
          icon="history"
          type="button"
          key="historyButtonKey"
          onClick={() => {
            localStorage.removeItem('defaultFilteredListOverride');
            history.push(`${routerBasename}/overview/history/${id}`);
          }}
          label={t('details.page.history.button.tooltip')}
        />
      );
    }

    if ([EDIT_MODE, VIEW_MODE].includes(mode) && routerBasename === ChemicalProduct.baseName) {
      options.left.push(
        <Popup
          key="details.page.inventory.overview.button.tooltip"
          trigger={
            <Button
              icon="icon-tube-list"
              type="button"
              key="inventoryButtonKey"
              size="mini"
              onClick={() => {
                localStorage.removeItem('defaultFilteredListOverride');
                history.push({
                  pathname: `${Inventory.baseName}/overview/entity/`,
                  state: {
                    userDefaultFilterProp: defaultFilterColumn.GEN_TRADE_CHEMICAL_NAMES,
                    chemicalProductId: id,
                  },
                });
              }}
            />
          }
          on={['hover']}
          size="mini"
          wide="very"
          content={t('details.page.inventory.overview.button.tooltip')}
          position="bottom left"
        />
      );
    }

    if (showReportProblemButton(mode)) {
      options.right.push(
        <Button
          type="button"
          key="reportProblemButtonKey"
          color={'orange'}
          onClick={() => history.push(`${routerBasename}/report/${id}`)}
        >
          {t('details.page.report.button')}
        </Button>
      );
    }

    if ([EDIT_MODE, VIEW_MODE].includes(mode) && routerBasename === Inventory.baseName) {
      options.left.push(
        <ButtonWrapper
          type="button"
          icon="building"
          key="buildingButtonKey"
          onClick={() => history.push(`/buildings/num/${initialValues.location.buildingNum}`)}
          label={t('details.building.button.tooltip')}
        />
      );
    }

    if ([VIEW_MODE].includes(mode) && routerBasename === Inventory.baseName) {
      const defaultTitle =
        initialValues?.chemicalProduct?.formula ?? initialValues?.chemicalProduct?.tradeName;
      options.left.push(
        <DownloadInventoryStickersModal
          selectedInventoriesDict={{ [currentInventoryId]: true }}
          gridTemplateCreatorOptions={gridTemplatesOptions}
          downloadFileName={`inventory-${defaultTitle}-qr-sticker.pdf`.replace(/\s+/g, '')}
          drawBox={false}
        />
      );
    }
    return options;
  };

  let options = getOptions();

  return (
    <div className="detailsFormOptions">
      {options.left}
      <Button.Group className="mini right floated">{options.right}</Button.Group>
    </div>
  );
};

const mapStateToProps = state => ({
  isReportLoading: state.reports.isReportLoading,
  currentInventoryId: state?.inventories?.inventory?.id,
});

const mapDispatchToProps = dispatch => ({
  getInventoryReport: id =>
    dispatch(reportsActions.getReport(GET_SELECTED_INVENTORIES_REPORT_PATH + GET_PDF_FORMAT, id)),
  toggleValidationMessage: () => dispatch(genericDetailsActions.toggleValidationMessage()),
});

export default withRouter(
  compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(DetailsFormOptions)
);
